import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';


export const SHARED_MODULES_ANGULAR = [
  RouterModule,
  ReactiveFormsModule,
  FormsModule
];
